import { createApp } from 'vue'
import { AstraCookieAccept } from '@platform/astra-vue'
// import '@platform/astra-vue/dist/astra-vue.mjs.css'

const App = {
  components: { AstraCookieAccept },
  template: `
    <AstraCookieAccept>
      <template #message>
        Пользуясь сайтом, Вы даете согласие на <a href="/cookie/" target="_blank">использование файлов cookies</a>
      </template>

      <template #decline>
        Не согласен
      </template>

      <template #accept>
        Принять
      </template>

      <template #postpone>
        ×
      </template>
    </AstraCookieAccept>
  `
}

export const createCookieAccept = () => {
  return createApp(App).mount('#cookie-accept-component')
}
